import React from "react";

import "./StatusLabelTag.css";

export default function StatusLabelTag({
  icon,
  children,
  tone = "healthy",
  variant = "filled",
  wrap = false,
  className = "",
}) {
  const resolvedTone = [
    "healthy",
    "warning",
    "critical",
    "muted",
    "positive",
    "info",
  ].includes(tone) ? tone : "healthy";

  const rootClass = [
    "StatusLabelTag",
    `StatusLabelTag--${resolvedTone}`,
    variant === "plain" ? "StatusLabelTag--plain" : "",
    wrap ? "StatusLabelTag--wrap" : "",
    className,
  ].filter(Boolean).join(" ");

  return (
    <span className={rootClass}>
      {icon && (
        <span className="StatusLabelTag__Icon" aria-hidden>
          {icon}
        </span>
      )}
      {children}
    </span>
  );
}
